var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.831,8.341a.89.89,0,0,1,0,1.267l-7.678,7.6a.911.911,0,0,1-1.279,0,.89.89,0,0,1,0-1.267l5.887-5.831H1A.9.9,0,1,1,1,8.321H19.254L12.874,2a.89.89,0,0,1,0-1.267.911.911,0,0,1,1.28,0Z",
    transform: "translate(0.904 3.526)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowRight);
export default __webpack_public_path__ + "static/media/icon.arrow-right.8aa18a752c8b2a48bba887bd2b67651d.svg";
export { ForwardRef as ReactComponent };